export default __webpack_public_path__ + "static/media/pencil.a1e63dbe.svg";